import API from "../../apiConfig";

export const getCustomerData = async () => {
  const response = await API.get(`/promotion/customers`);
  return response;
};

export const uploadCustomerData = async (data) => {
  const response = await API.post("/promotion/uploadCustomers", data);
  return response;
};
export const signleCustomerUpload = async (data) => {
  const response = await API.post("/promotion/customer", data);
  return response;
};